import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** Highlight the badge (e.g., active nav item count) */
  highlight?: boolean;
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { highlight = false, className, children, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      className={cn(
        'inline-flex min-w-[18px] items-center justify-center rounded-full font-mono text-eyebrow tracking-normal',
        'px-1.5 py-[1px] leading-none tabular-nums',
        highlight ? 'bg-brand-soft text-brand-ink' : 'bg-rail text-t2',
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
});
